export enum InvestigationRespondentRequestType {
	AdditionalPeriod = 1,
	Excuse = 2,
}
